import { c as _c } from "react/compiler-runtime";
import { useTranslation } from "@/app/i18n/client";
import { AddressWithLocation, defaultAddressWithLocation } from "@/types/location";
import PlaceAutocomplete from "../PlaceAutocomplete";

// eslint-disable-next-line import/no-unused-modules
export interface LocationFilterFieldProps {
  name: string;
  placeholder?: string;
  setLocation: (location: AddressWithLocation | null) => void;
  initialValue?: AddressWithLocation | null;
}
export default function LocationFilterField(props) {
  const $ = _c(11);
  const {
    t
  } = useTranslation();
  let t0;
  if ($[0] !== props) {
    t0 = () => props.setLocation(null);
    $[0] = props;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== props.placeholder || $[3] !== t) {
    t1 = props.placeholder || t("MAIN.SEARCHLOCATION.TEXT");
    $[2] = props.placeholder;
    $[3] = t;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const t2 = props.initialValue ? props.initialValue : undefined;
  let t3;
  if ($[5] !== props.name || $[6] !== props.setLocation || $[7] !== t0 || $[8] !== t1 || $[9] !== t2) {
    t3 = <div className="locationFilterField"><PlaceAutocomplete name={props.name} resultsListClassName="dark-theme scrollList" onClear={t0} placeholder={t1} setLocation={props.setLocation} initialValue={t2} className="bg-white" /></div>;
    $[5] = props.name;
    $[6] = props.setLocation;
    $[7] = t0;
    $[8] = t1;
    $[9] = t2;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  return t3;
}